import { RuntimeNotifier } from "@opendaw/lib-std";
import { Promises } from "@opendaw/lib-runtime";
export var Clipboard;
(function (Clipboard) {
    Clipboard.writeText = async (text) => {
        const result = await Promises.tryCatch(navigator.clipboard.writeText(text));
        if (result.status === "rejected") {
            await RuntimeNotifier.info({
                headline: "Clipboard Error",
                message: "Could not write to clipboard. Please check your browser permissions."
            });
        }
    };
    Clipboard.readText = async () => {
        const result = await Promises.tryCatch(navigator.clipboard.readText());
        if (result.status === "resolved") {
            return result.value;
        }
        await RuntimeNotifier.info({
            headline: "Clipboard Error",
            message: "Could not read from clipboard. Please check your browser permissions."
        });
        return "";
    };
})(Clipboard || (Clipboard = {}));
